import { Inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

import { LOCAL_STORAGE, SESSION_STORAGE } from '@app/modules/core/tokens/app.tokens';
import { LocalStorage } from '@app/modules/core/interfaces/local-storage';
import { SessionStorage } from '@app/modules/core/interfaces/session-storage';
import { AUTH_TOKEN, ITINERARY_ID_TRACK_EVENT, SEAMLESS_LOGIN } from '@app/modules/core/constants/auth.constants';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    @Inject(LOCAL_STORAGE) private localStorage: LocalStorage,
    @Inject(SESSION_STORAGE) private sessionStorage: SessionStorage,
    private cookieService: CookieService
  ) { }

  public authToken(): string {
    return this.localStorage.getItem(AUTH_TOKEN);
  }

  public removeToken(): void {
    this.localStorage.removeItem(AUTH_TOKEN);
    this.sessionStorage.removeItem(ITINERARY_ID_TRACK_EVENT);
    this.cookieService.delete(SEAMLESS_LOGIN);
  }

  public authTokenLocalStorage(): string | null {
    return this.localStorage.getItem(AUTH_TOKEN);
  }

}
